import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import React from 'react'
import styled from 'styled-components'
import { AnnotationElement } from '../AnnotatedElement'
import { AnnotationType } from '../AnnotatedElement/types'

export const AnnotatedMap = ({
  image,
  annotations,
  screenHeight = false,
  windowSize,
  title,
  source,
}: {
  image: string
  annotations: AnnotationType[]
  screenHeight?: boolean
  windowSize: { width: number; height: number }
  title?: string | React.ReactNode
  source?: string
}) => {
  return (
    <>
      {title && (
        <TextWidth>
          <div className='title'>{title}</div>
        </TextWidth>
      )}
      <Container
        screenHeight={screenHeight}
        height={windowSize.height}
        className='MAPCONTAINER'
      >
        <AnnotationElement
          // debug
          defaults={{
            anchor: 'top',
            distance: 100,
            connect: true,
            connector: {
              type: 'curved',
              style: { stroke: '#202346', strokeWidth: 1 },
              direction: 'clockwise',
            },
          }}
          annotations={annotations}
          move={{ x: 0, y: 0 }}
        >
          <img src={image} alt='Karte der Antarktis' />
        </AnnotationElement>
      </Container>
      {source && (
        <TextWidth>
          <div className='source'>{source}</div>
        </TextWidth>
      )}
    </>
  )
}
const Container = styled.div<{ screenHeight: boolean; height: number }>`
  font-family: var(--font-sans-serif);
  display: flex;
  justify-content: center;
  width: 100%;
  margin-left: 0;

  img {
    max-width: ${({ screenHeight }) => (screenHeight ? 'unset' : '100%')};
    max-height: ${({ screenHeight, height }) =>
      screenHeight ? height * 0.75 + 'px' : 'unset'};
  }
  @media only screen and (max-width: 800px) {
    width: 200%;
    margin-left: -50%;
  }
`
